import cinemaIntelligenceImage from "../assets/cinemaAnalyticsP.png";
import autoIntelligenceImage from "../assets/auto.png";
import retailIntelligenceImage from "../assets/retail.png";
import travelIntelligenceImage from "../assets/travel.png";
import realEstateIntelligenceImage from "../assets/realestate.png";
import wellnessIntelligenceImage from "../assets/wellness.png";
import nonprofitIntelligenceImage from "../assets/publicsector.png";
import educationIntelligenceImage from "../assets/education.png";
import cpgIntelligenceImage from "../assets/cpg.png";
import healthcareIntelligenceImage from "../assets/healthcare.png";
import b2bIntelligenceImage from "../assets/b2b.png";
import cryptoIntelligenceImage from "../assets/crypto.png";
import financeIntelligenceImage from "../assets/finance.png";
import foodBeverageIntelligenceImage from "../assets/restaurants.png";
import gamingIntelligenceImage from "../assets/categories/gaming.png";
import telecomIntelligenceImage from "../assets/categories/telecom.png";
import electronicsIntelligenceImage from "../assets/categories/electronics.png";
import marketIntelligenceImage from "../assets/marketanalytics.jpg";
import { normalizeAdvertiserVertical } from "./verticalIntelligenceConfig";

export {
  ADVERTISER_VERTICAL_OPTIONS,
  SUPPORTED_ADVERTISER_VERTICALS,
  formatAdvertiserVerticalLabel,
  normalizeAdvertiserVertical,
} from "./verticalIntelligenceConfig";

const FALLBACK_IMAGE = marketIntelligenceImage;

export const VERTICAL_DASHBOARD_CONFIG = {
  general: {
    vertical: "general",
    displayLabel: "General",
    dashboardTileLabel: "GENERAL",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: marketIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "General Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "General",
      focus:
        "audience intent, platform response, market signals, conversion quality, creative effectiveness, campaign optimization",
    },
    fallbackBehavior: "Use general intelligence language for advertisers without a vertical-specific model.",
  },
  film: {
    vertical: "film",
    displayLabel: "Film / Entertainment",
    dashboardTileLabel: "CINEMA",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: cinemaIntelligenceImage || FALLBACK_IMAGE,
    route: "/cinema-analytics",
    pageTitle: "Cinema Intelligence",
    enabledModules: ["cinema-intelligence", "moviegoer-response", "theatrical-market"],
    aiContextLabels: {
      sector: "Film / Entertainment",
      focus:
        "theatrical awareness, ticketing intent, moviegoer response, cinema market performance",
    },
    fallbackBehavior: "Keep existing Cinema Intelligence behavior.",
  },
  automotive: {
    vertical: "automotive",
    displayLabel: "Automotive",
    dashboardTileLabel: "AUTO",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: autoIntelligenceImage || FALLBACK_IMAGE,
    tileImageFit: "contain",
    tileImagePosition: "center",
    tileImageRepeat: "no-repeat",
    route: "/auto-intelligence",
    pageTitle: "Auto Intelligence",
    enabledModules: [
      "auto-intelligence",
      "audience-intent",
      "vehicle-interest",
      "dealer-geo-performance",
      "lead-quality-signals",
      "creative-offer-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Automotive",
      focus:
        "in-market shopper behavior, vehicle interest, dealer territory performance, lead quality, inventory-aligned demand",
    },
    fallbackBehavior: "Use automotive-specific labels and avoid entertainment-specific language.",
  },
  retail: {
    vertical: "retail",
    displayLabel: "Retail / E-Commerce",
    dashboardTileLabel: "RETAIL",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: retailIntelligenceImage || FALLBACK_IMAGE,
    tileImageFit: "contain",
    tileImagePosition: "center",
    tileImageRepeat: "no-repeat",
    route: "/retail-intelligence",
    pageTitle: "Retail Intelligence",
    enabledModules: [
      "retail-intelligence",
      "shopper-intent",
      "product-menu-performance",
      "store-geo-performance",
      "conversion-order-signals",
      "creative-offer-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Retail / E-Commerce",
      focus:
        "shopper behavior, product and menu interest, delivery behavior, purchase intent, conversion efficiency, cart and site engagement",
    },
    fallbackBehavior: "Use retail and e-commerce intelligence language.",
  },
  travel_hospitality: {
    vertical: "travel_hospitality",
    displayLabel: "Travel / Hospitality",
    dashboardTileLabel: "TRAVEL",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: travelIntelligenceImage || FALLBACK_IMAGE,
    route: "/travel-intelligence",
    pageTitle: "Travel Intelligence",
    enabledModules: [
      "travel-hospitality-intelligence",
      "traveler-intent",
      "destination-demand",
      "origin-market-response",
      "booking-consideration",
      "creative-offer-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Travel / Hospitality",
      focus:
        "destination demand, traveler intent, booking consideration, guest engagement, origin-market response, and seasonal travel planning",
    },
    fallbackBehavior: "Use travel and hospitality intelligence language on shared intelligence surfaces.",
  },
  financial_services: {
    vertical: "financial_services",
    displayLabel: "Financial Services",
    dashboardTileLabel: "FINANCE",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: financeIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Finance Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Financial Services",
      focus:
        "account acquisition, application starts, qualified leads, audience qualification, compliance-safe trust building",
    },
    fallbackBehavior: "Use the shared general intelligence page until a finance-specific intelligence page ships.",
  },
  crypto_web3: {
    vertical: "crypto_web3",
    displayLabel: "Blockchain / Crypto / Web3",
    dashboardTileLabel: "CRYPTO",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: cryptoIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Crypto Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Blockchain / Crypto / Web3",
      focus:
        "community growth, wallet and account intent, compliant onboarding, product understanding, education-led trust",
    },
    fallbackBehavior: "Use the shared general intelligence page until a crypto-specific intelligence page ships.",
  },
  health_wellness: {
    vertical: "health_wellness",
    displayLabel: "Health / Wellness",
    dashboardTileLabel: "WELLNESS",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: wellnessIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Wellness Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Health / Wellness",
      focus:
        "wellness awareness, booking and appointment intent, membership interest, routine building, community trust",
    },
    fallbackBehavior: "Use the shared general intelligence page until a wellness-specific intelligence page ships.",
  },
  healthcare_public_health: {
    vertical: "healthcare_public_health",
    displayLabel: "Healthcare / Public Health",
    dashboardTileLabel: "HEALTHCARE",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: healthcareIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Healthcare Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Healthcare / Public Health",
      focus:
        "patient education, service-line awareness, appointment intent, access and prevention, community trust",
    },
    fallbackBehavior: "Use the shared general intelligence page until a healthcare-specific intelligence page ships.",
  },
  education: {
    vertical: "education",
    displayLabel: "Education",
    dashboardTileLabel: "EDUCATION",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: educationIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Education Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Education",
      focus:
        "program awareness, enrollment interest, applications, information sessions, admissions-funnel movement",
    },
    fallbackBehavior: "Use the shared general intelligence page until an education-specific intelligence page ships.",
  },
  b2b_saas: {
    vertical: "b2b_saas",
    displayLabel: "B2B / SaaS",
    dashboardTileLabel: "B2B",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: b2bIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "B2B Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "B2B / SaaS",
      focus:
        "pipeline influence, qualified leads, demo requests, account-based audiences, product education",
    },
    fallbackBehavior: "Use the shared general intelligence page until a B2B-specific intelligence page ships.",
  },
  nonprofit_public_sector: {
    vertical: "nonprofit_public_sector",
    displayLabel: "Nonprofit / Public Sector",
    dashboardTileLabel: "NONPROFIT",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: nonprofitIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Nonprofit Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Nonprofit / Public Sector",
      focus:
        "community impact, awareness and education, donations where applicable, volunteer interest, civic action",
    },
    fallbackBehavior: "Use the shared general intelligence page until a nonprofit-specific intelligence page ships.",
  },
  real_estate: {
    vertical: "real_estate",
    displayLabel: "Real Estate",
    dashboardTileLabel: "REAL ESTATE",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: realEstateIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Real Estate Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Real Estate",
      focus:
        "listing awareness, property inquiries, open houses, neighborhood interest, buyer and seller intent",
    },
    fallbackBehavior: "Use the shared general intelligence page until a real-estate-specific intelligence page ships.",
  },
  food_beverage: {
    vertical: "food_beverage",
    displayLabel: "Food / Beverage / Restaurants",
    dashboardTileLabel: "FOOD",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: foodBeverageIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Food & Beverage Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Food / Beverage / Restaurants",
      focus:
        "reservations, orders and delivery, foot traffic, menu awareness, local demand",
    },
    fallbackBehavior: "Use the shared general intelligence page until a food-and-beverage-specific intelligence page ships.",
  },
  cpg: {
    vertical: "cpg",
    displayLabel: "CPG",
    dashboardTileLabel: "CPG",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: cpgIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "CPG Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "CPG",
      focus:
        "product discovery, category awareness, trial rates, repeat purchase, retailer availability",
    },
    fallbackBehavior: "Use the shared general intelligence page until a CPG-specific intelligence page ships.",
  },
  gaming: {
    vertical: "gaming",
    displayLabel: "Gaming",
    dashboardTileLabel: "GAMING",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: gamingIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Gaming Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Gaming",
      focus:
        "player acquisition, install intent, player retention, engagement depth, community and esports response",
    },
    fallbackBehavior: "Use the shared general intelligence page until a gaming-specific intelligence page ships.",
  },
  telecom: {
    vertical: "telecom",
    displayLabel: "Telecom",
    dashboardTileLabel: "TELECOM",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: telecomIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Telecom Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Telecom",
      focus:
        "plan adoption, coverage confidence, switching intent, line activations, household and business connectivity",
    },
    fallbackBehavior: "Use the shared general intelligence page until a telecom-specific intelligence page ships.",
  },
  electronics: {
    vertical: "electronics",
    displayLabel: "Electronics",
    dashboardTileLabel: "ELECTRONICS",
    dashboardTileBadge: "INTELLIGENCE",
    tileImage: electronicsIntelligenceImage || FALLBACK_IMAGE,
    route: "/general-intelligence",
    pageTitle: "Electronics Intelligence",
    enabledModules: [
      "general-intelligence",
      "audience-intent",
      "platform-response",
      "market-signals",
      "conversion-quality",
      "creative-performance",
      "recommended-optimizations",
    ],
    aiContextLabels: {
      sector: "Electronics",
      focus:
        "device consideration, feature comparison, purchase intent, launch response, retail and ecommerce consideration",
    },
    fallbackBehavior: "Use the shared general intelligence page until an electronics-specific intelligence page ships.",
  },
};

export function resolveVerticalDashboardConfig(value) {
  const vertical = normalizeAdvertiserVertical(value);
  return VERTICAL_DASHBOARD_CONFIG[vertical] || VERTICAL_DASHBOARD_CONFIG.general;
}

export function resolveVerticalDashboardConfigForAdvertiser(advertiser) {
  return resolveVerticalDashboardConfig(advertiser?.vertical);
}

export function getVerticalDashboardImagePreloadUrls() {
  return Array.from(
    new Set(
      Object.values(VERTICAL_DASHBOARD_CONFIG)
        .map((config) => config.tileImage || FALLBACK_IMAGE)
        .filter(Boolean)
    )
  );
}
